export const translations = {
  en: {
    typePlaceholder: 'Share your opinion',
    poweredBy: 'Powered by',
    errorMessage: 'Something went wrong. Please, reload this page and try again.',
    metaTitle: 'Rate your experience with {brand}',
    metaDescription: 'Tell us how we did so that we can improve our services',
    conversationCompleted: 'The satisfaction survey has completed, you may now close this window'
  },
  es: {
    typePlaceholder: 'Comparte tu opinión',
    poweredBy: 'Desarrollado por',
    errorMessage: 'Algo salió mal. Por favor, recarga esta página e inténtalo de nuevo.',
    metaTitle: 'Califica tu experiencia con {brand}',
    metaDescription: 'Cuéntanos qué tal lo hicimos para que podamos mejorar nuestros servicios',
    conversationCompleted: 'La encuesta de satisfacción se ha completado, ahora puedes cerrar esta ventana'
  },
  fr: {
    typePlaceholder: 'Partagez votre avis',
    poweredBy: 'Alimenté par',
    errorMessage: 'Quelque chose s\'est mal passé. Veuillez recharger cette page et réessayer.',
    metaTitle: 'Évaluez votre expérience avec {brand}',
    metaDescription: 'Dites-nous comment nous avons fait pour que nous puissions améliorer nos services',
    conversationCompleted: 'L\'enquête de satisfaction est terminée, vous pouvez maintenant fermer cette fenêtre'
  },
  nl: {
    typePlaceholder: 'Deel je mening',
    poweredBy: 'Mogelijk gemaakt door',
    errorMessage: 'Er is iets misgegaan. Laad deze pagina opnieuw en probeer het opnieuw.',
    metaTitle: 'Beoordeel je ervaring met {brand}',
    metaDescription: 'Vertel ons hoe we het gedaan hebben zodat we onze diensten kunnen verbeteren',
    conversationCompleted: 'De chat is voltooid en deze pagina kan nu worden gesloten'
  },
  it: {
    typePlaceholder: 'Condividi la tua opinione',
    poweredBy: 'Offerto da',
    errorMessage: 'Qualcosa è andato storto. Per favore, ricarica questa pagina e riprova.',
    metaTitle: 'Valuta la tua esperienza con {brand}',
    metaDescription: 'Dicci come abbiamo fatto in modo da poter migliorare i nostri servizi',
    conversationCompleted: 'Il sondaggio di soddisfazione è stato completato, ora puoi chiudere questa finestra'
  },
  de: {
    typePlaceholder: 'Teilen Sie Ihre Meinung',
    poweredBy: 'Unterstützt von',
    errorMessage: 'Etwas ist schief gelaufen. Bitte laden Sie diese Seite neu und versuchen Sie es erneut.',
    metaTitle: 'Bewerten Sie Ihre Erfahrung mit {brand}',
    metaDescription: 'Sagen Sie uns, wie wir abgeschnitten haben, damit wir unsere Dienstleistungen verbessern können',
    conversationCompleted: 'Die Zufriedenheitsbefragung ist abgeschlossen, Sie können dieses Fenster nun schließen'
  }
};

// Helper function to get translation with fallback
export function getTranslation(translations, language, key, replacements = {}) {
  const languageCode = language ? language.split('-')[0] : 'en';
  let translation = translations[languageCode]?.[key] || translations.en[key] || key;
  
  // Replace placeholders like {brand} with actual values
  Object.keys(replacements).forEach(placeholder => {
    translation = translation.replace(`{${placeholder}}`, replacements[placeholder]);
  });
  
  return translation;
}

// Helper function to set language based on API response
export function getLanguageCode(language) {
  if (!language) return 'en';
  
  const languageCode = language.split('-')[0];
  const supportedLanguages = ['en', 'es', 'fr', 'nl', 'it', 'de'];
  return supportedLanguages.includes(languageCode) ? languageCode : 'en';
} 
